var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0258 12.8473L17.5947 16.4162L16.4162 17.5947L12.8473 14.0258C11.564 15.0525 9.93663 15.6667 8.16663 15.6667C4.02663 15.6667 0.666626 12.3067 0.666626 8.16666C0.666626 4.02666 4.02663 0.666656 8.16663 0.666656C12.3066 0.666656 15.6666 4.02666 15.6666 8.16666C15.6666 9.93666 15.0525 11.5641 14.0258 12.8473ZM12.3539 12.229C13.3729 11.1788 14 9.74632 14 8.16666C14 4.94374 11.3895 2.33332 8.16663 2.33332C4.94371 2.33332 2.33329 4.94374 2.33329 8.16666C2.33329 11.3896 4.94371 14 8.16663 14C9.74629 14 11.1788 13.3729 12.229 12.3539L12.3539 12.229Z",
    fill: "#3B3E63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.655591f466f026b672bee12b906ea75b.svg";
export { ForwardRef as ReactComponent };